<div
  *ngIf="vm$ | async as vm"
  class="pathway-header"
  [class.pathway-header--no-hero]="vm.hideHeaderImage"
>
  <div class="pathway-header__wrapper">
    <div
      class="pathway-header__meta"
      [class.hero-image__wrapper]="!vm.hideHeaderImage"
    >
      <dgx-hero-image
        *ngIf="!vm.hideHeaderImage"
        [imageSrc]="displayImageSrcset(vm.pathway?.imageUrl)"
      ></dgx-hero-image>
      <div
        [ngClass]="
          vm.hideHeaderImage
            ? 'grid grid--bleed'
            : 'vertical-center center-text'
        "
      >
        <div [class.grid__col-sm-7]="vm.hideHeaderImage">
          <h1 class="h1 pathway-header__title hero-image__text guts-p-b-1">
            {{ vm.pathway.title }}
          </h1>
          <div class="pathway-header__info">
            <img
              *ngIf="vm.pathway.isEndorsed && vm.endorsedImageUrl"
              [src]="vm.endorsedImageUrl"
              [ngbTooltip]="i18n.Core_EndorsedTooltip"
              [alt]="'Core_Endorsed' | translate"
              class="pathway-header__endorsed"
            />
            <ul class="meta-list meta-list--bullets hero-image__text">
              <li *ngIf="vm.totalStepsDisplay">
                {{ vm.totalStepsDisplay }}
              </li>
              <li *ngIf="vm.sectionTotalDisplay">
                {{ vm.sectionTotalDisplay }}
              </li>
              <ng-container *ngIf="!vm.pathway.durationDisplayDisabled">
                <li *ngIf="vm.durationHours">
                  {{ vm.durationHours }}
                </li>
                <li *ngIf="vm.durationMinutes">
                  {{ vm.durationMinutes }}
                </li>
              </ng-container>
              <li *ngIf="vm.optionalStepsDisplay">
                {{ vm.optionalStepsDisplay }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="pathway-header__progress">
      <dgx-progress-circle
        [percent]="vm.pathway.progress"
        [config]="{
          radius: 40,
          stroke: 4,
          padding: 4,
          checkmark: 'large'
        }"
      >
        <span class="h2">{{ vm.pathway.progress }}</span>
        <span class="h3">%</span>
      </dgx-progress-circle>
    </div>
  </div>
  <div class="grid grid--bleed guts-p-t-2 m-guts-p-t-0">
    <div class="grid__col-sm-8">
      <dgx-text-expander
        *ngIf="vm.pathway.description"
        [class.guts-p-t-2]="!vm.hideHeaderImage"
        class="par markdown"
        [content]="
          vm.pathway.description | markdownToHtml: { allowImages: true }
        "
        [isHtml]="true"
        [maxCollapsedLines]="2"
        [useReadMore]="true"
        [collapse]="true"
      ></dgx-text-expander>

      <div
        *ngIf="displayPathwayAuthors || !vm.isChannel"
        class="guts-p-t-2 l_flexbar m-l_flexbar-col"
      >
        <ng-container *ngIf="displayPathwayAuthors">
          <div
            class="
              par par--small
              guts-m-r-quart guts-p-r-2-half
              m-guts-p-r-0
              l_flexbar
            "
          >
            <div class="guts-p-r-half font-semibold">
              {{ i18n.Pathways_Collaborators }}:
            </div>
            <dgx-users-pictures
              class="full-width"
              [users]="vm.pathway.authors"
              [isEditing]="vm.isEditMode && isOrgUser"
              [wrap]="true"
              manageUsersTooltip="Pathways_Collaborators"
              (onEdit)="editAuthors()"
            ></dgx-users-pictures>
          </div>
        </ng-container>
        <ng-container *ngIf="!vm.isChannel">
          <p
            *ngIf="!vm.isEditMode; else editing"
            class="par par--small m-guts-p-t-1"
          >
            {{ vm.visibilityLabel | translate }}
          </p>
          <ng-template #editing>
            <button
              class="par par--small uhover no-wrap m-guts-p-t-1"
              (click)="setVisibilityLevel()"
              data-dgat="pageHeader-886"
            >
              <span>{{ vm.visibilityLabel }}</span>
              <df-icon class="guts-p-l-half" icon="chevron-down"></df-icon>
            </button>
          </ng-template>
        </ng-container>
      </div>
    </div>
    <ng-container *ngIf="showPageActions">
      <div class="grid__col-sm-4 m-guts-p-t-1 pathway-header__actions">
        <dgx-pathway-page-actions
          class="l_flex--align-right l_flex--align-right--no-mobile"
        ></dgx-pathway-page-actions>
      </div>
    </ng-container>
  </div>
</div>
